{
  "login-secret-with-pin-page": {
    "buttons": {
      "resend": "Renvoyer",
      "submit": "Soumettre"
    },
    "text": {
      "in-second": "en {{seconds}} s",
      "pin-email-invalid": "Le code PIN est incorrect. Veuillez le vérifier dans votre e-mail et réessayer.",
      "pin-sms-invalid": "Le code PIN est incorrect. Veuillez le vérifier dans votre SMS et réessayer.",
      "resend-pin-hint": "Vous n'avez pas reçu de code PIN ?",
      "verify-email": "Vérifiez votre adresse e-mail",
      "verify-phone-nr": "Vérifiez votre numéro de téléphone",
      "verify-update": "Vérifiez votre mise à jour",
      "verify-update-by-email": "Vous recevrez un PIN de confirmation par email",
      "verify-update-by-sms": "Vous recevrez un PIN de confirmation par SMS"
    }
  }
}
